export default __webpack_public_path__ + "static/media/presentation.946a0fc3.jpg";